import { render, staticRenderFns } from "./ResumenOferta.vue?vue&type=template&id=21ce4989&scoped=true"
import script from "./ResumenOferta.vue?vue&type=script&lang=ts"
export * from "./ResumenOferta.vue?vue&type=script&lang=ts"
import style0 from "./ResumenOferta.vue?vue&type=style&index=0&id=21ce4989&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce4989",
  null
  
)

export default component.exports